/* ==============================================================
   THE FIRST $100,000 CALCULATOR — v2.0 — mikeymoran.com
   Markup: sections/first-100k-calculator.liquid
   Styles: assets/first-100k.css

   Math (unchanged from v1): every month the balance grows by
   rate / 12, then the monthly deposit lands. Milestones at $100K,
   $200K and $300K. 75-year cap.

   New in v2: deposits-vs-growth split per milestone, growth curve,
   saved inputs (localStorage k100.v1), ?start=&monthly=&rate= prefill,
   copy-link, honest form success (waits for the post to finish).
   MailerLite form 43944199 and its hidden fields (k_start, k_monthly,
   k_timeline) are unchanged.
   ============================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-mmk]');
  if (!root) { return; }

  var STORE = 'k100.v1';
  var DEF = { start: 10000, monthly: 1000, rate: 7 };
  var TARGETS = [100000, 200000, 300000];
  var NAMES = ['first', 'second', 'third'];
  var CAP = 900; // months (75 years)

  function $(id) { return document.getElementById(id); }
  function on(el, ev, fn) { if (el) { el.addEventListener(ev, fn); } }

  var el = {
    start: $('mkStart'), monthly: $('mkMonthly'), rate: $('mkRate'), rateOut: $('mkRateOut'),
    eyebrow: $('mkEyebrow'), date: $('mkDate'), cap: $('mkCap'), insight: $('mkInsight'),
    chart: $('mkChart'), chartNote: $('mkChartNote'), msg: $('mkMsg'),
    dock: $('mkDock'), dockV: $('mkDockV'), result: $('mkResult'), badge: $('mkBadge'),
    hidStart: $('mkHidStart'), hidMonthly: $('mkHidMonthly'), hidTimeline: $('mkHidTimeline')
  };
  var chips = root.querySelectorAll('[data-monthly]');
  var rows = [0, 1, 2].map(function (i) {
    var r = $('mkMs' + (i + 1));
    return r && {
      row: r, time: r.querySelector('[data-o="time"]'), fill: r.querySelector('.mmk-ms-fill'),
      you: r.querySelector('.mmk-ms-you'), split: r.querySelector('[data-o="split"]')
    };
  });

  /* ---------- helpers ---------- */
  function num(v) {
    var x = parseFloat(String(v == null ? '' : v).replace(/[^0-9.]/g, ''));
    return isFinite(x) && x > 0 ? x : 0;
  }
  function money(n) { return '$' + Math.round(n).toLocaleString('en-US'); }
  function moneyK(n) {
    if (n >= 1e6) { return '$' + (Math.round(n / 1e5) / 10) + 'M'; }
    return '$' + Math.round(n / 1000) + 'K';
  }
  function durShort(m) {
    var y = Math.floor(m / 12), mo = m % 12;
    if (y === 0) { return mo + (mo === 1 ? ' month' : ' months'); }
    if (mo === 0) { return y + (y === 1 ? ' year' : ' years'); }
    return y + 'y ' + mo + 'm';
  }
  function durLong(m) {
    var y = Math.floor(m / 12), mo = m % 12, out = [];
    if (y) { out.push(y + (y === 1 ? ' year' : ' years')); }
    if (mo) { out.push(mo + (mo === 1 ? ' month' : ' months')); }
    return out.join(', ') || '0 months';
  }
  function dateIn(m, long) {
    var d = new Date();
    d.setDate(1);
    d.setMonth(d.getMonth() + m);
    return d.toLocaleDateString('en-US', { month: long ? 'long' : 'short', year: 'numeric' });
  }
  function clampRate(v) {
    var x = parseFloat(v);
    if (!isFinite(x)) { return DEF.rate; }
    return Math.min(12, Math.max(1, Math.round(x * 2) / 2));
  }
  function store(get, val) {
    try {
      if (get) { return JSON.parse(localStorage.getItem(STORE) || 'null'); }
      localStorage.setItem(STORE, JSON.stringify(val));
    } catch (e) { return null; }
    return null;
  }

  /* ---------- simulation ---------- */
  function simulate(start, monthly, annual) {
    var r = annual / 100 / 12, b = start, dep = start, m = 0, ti = 0, ms = [];
    while (ti < TARGETS.length && b >= TARGETS[ti]) { ms.push({ t: TARGETS[ti], done: true, m: 0 }); ti++; }
    // Baseline: if nothing is behind you yet, the first segment counts your
    // starting balance as money you put in. Otherwise measure from today.
    var baseB = ms.length ? start : 0, baseD = ms.length ? start : 0, baseM = 0;
    while (ti < TARGETS.length && m < CAP) {
      b = b * (1 + r) + monthly; dep += monthly; m++;
      while (ti < TARGETS.length && b >= TARGETS[ti]) {
        var gain = b - baseB, put = dep - baseD;
        var you = gain > 0 ? Math.max(0, Math.min(100, Math.round((put / gain) * 100))) : 0;
        ms.push({ t: TARGETS[ti], m: m, dur: m - baseM, you: you, growth: 100 - you, put: put, gain: gain });
        baseB = b; baseD = dep; baseM = m; ti++;
      }
    }
    while (ti < TARGETS.length) { ms.push({ t: TARGETS[ti], never: true }); ti++; }
    return ms;
  }
  function series(start, monthly, annual, end) {
    var r = annual / 100 / 12, b = start, dep = start, out = [{ m: 0, b: b, d: dep }];
    for (var m = 1; m <= end; m++) { b = b * (1 + r) + monthly; dep += monthly; out.push({ m: m, b: b, d: dep }); }
    return out;
  }

  /* ---------- state ---------- */
  var state = { start: DEF.start, monthly: DEF.monthly, rate: DEF.rate };
  var last = null;

  function readInputs() {
    state.start = Math.min(num(el.start.value), 1e8);
    state.monthly = Math.min(num(el.monthly.value), 1e7);
    state.rate = clampRate(el.rate.value);
  }
  function fmtInput(input) {
    var x = num(input.value);
    input.value = x ? x.toLocaleString('en-US', { maximumFractionDigits: 2 }) : '';
  }

  /* ---------- render ---------- */
  function render(save) {
    readInputs();
    var s = state, ms = simulate(s.start, s.monthly, s.rate);
    var m1 = ms[0];
    last = { s: { start: s.start, monthly: s.monthly, rate: s.rate }, ms: ms };

    el.rateOut.textContent = s.rate + '%';
    if (el.badge) { el.badge.textContent = s.rate + '% a year'; }
    el.rate.style.setProperty('--p', ((s.rate - 1) / 11 * 100) + '%');
    el.rate.setAttribute('aria-valuetext', s.rate + ' percent a year');
    for (var c = 0; c < chips.length; c++) {
      chips[c].setAttribute('aria-pressed', String(Number(chips[c].getAttribute('data-monthly')) === s.monthly));
    }

    // headline
    var perMonth = '<strong>' + money(s.monthly) + '</strong> a month at an assumed <strong>' + s.rate + '%</strong> return';
    el.date.classList.toggle('is-word', !!(m1.done || m1.never));
    if (m1.never) {
      el.eyebrow.textContent = 'You cross $100,000';
      el.date.textContent = 'Not yet.';
      el.cap.innerHTML = 'Putting in ' + perMonth + ', you don’t reach $100,000 within 75 years. Raise the monthly number and watch the date move.';
    } else if (m1.done) {
      var allDone = ms[2].done;
      el.eyebrow.textContent = 'Your first $100,000';
      el.date.textContent = 'Done.';
      el.cap.innerHTML = allDone
        ? 'You’re past <strong>$300,000</strong>. This calculator’s job is done. The next question is what that money pays you.'
        : 'You’re already past it. The hard one is behind you. Here’s how fast the next ones come, putting in ' + perMonth + '.';
    } else {
      el.eyebrow.textContent = 'You cross $100,000';
      el.date.textContent = dateIn(m1.m);
      el.date.setAttribute('aria-label', dateIn(m1.m, true));
      el.cap.innerHTML = '<strong>' + durLong(m1.m) + '</strong> from now, putting in ' + perMonth + '.';
    }

    // milestone rows
    var maxDur = 0;
    ms.forEach(function (x) { if (x.dur > maxDur) { maxDur = x.dur; } });
    ms.forEach(function (x, i) {
      var r = rows[i];
      if (!r) { return; }
      r.row.classList.toggle('is-done', !!x.done);
      if (x.done) {
        r.time.textContent = 'Done ✓';
        r.fill.style.width = '0%';
        r.split.textContent = 'Already behind you.';
      } else if (x.never) {
        r.time.textContent = '75y+';
        r.fill.style.width = '0%';
        r.split.textContent = 'Not within 75 years at these numbers.';
      } else {
        r.time.textContent = durShort(x.dur);
        r.fill.style.width = (maxDur ? Math.max(4, x.dur / maxDur * 100) : 0) + '%';
        r.you.style.width = x.you + '%';
        r.split.textContent = x.you + '% your deposits · ' + x.growth + '% growth';
      }
    });

    // insight
    var fut = ms.filter(function (x) { return x.dur > 0; });
    var html;
    if (ms[2].done) {
      html = 'All three milestones are behind you. See what that money could cover with the <a href="/pages/dividend-calculator" style="color:#E5C892;font-weight:600">Dividend Coverage Tracker</a>.';
    } else if (m1.never) {
      html = 'The first $100,000 is the one that takes real time. Every one after it comes faster. Try a bigger monthly number.';
    } else if (fut.length >= 2) {
      var a = fut[0], z = fut[fut.length - 1];
      var aName = NAMES[TARGETS.indexOf(a.t)], zName = NAMES[TARGETS.indexOf(z.t)];
      var gap = a.dur - z.dur;
      var lead = s.monthly > 0 ? 'Same <b>' + money(s.monthly) + ' a month</b>. ' : 'No new money going in. ';
      html = gap > 0
        ? lead + 'Your ' + zName + ' $100,000 lands <b>' + durShort(gap) + ' faster</b> than your ' + aName + ', because growth builds <b>' + z.growth + '%</b> of it instead of <b>' + a.growth + '%</b>.'
        : lead + 'Growth builds <b>' + z.growth + '%</b> of your ' + zName + ' $100,000, versus <b>' + a.growth + '%</b> of your ' + aName + '. Raise the rate and watch the gap open up.';
    } else if (fut.length === 1) {
      html = 'Growth builds <b>' + fut[0].growth + '%</b> of this one. Keep going and every $100,000 after it comes faster.';
    } else {
      html = 'The first $100,000 is the one that takes real time. Every one after it comes faster.';
    }
    el.insight.innerHTML = html;

    // dock
    if (el.dockV) { el.dockV.textContent = m1.never ? 'Not yet' : (m1.done ? 'Done' : dateIn(m1.m)); }

    // MailerLite hidden fields (same format as v1)
    el.hidStart.value = money(s.start);
    el.hidMonthly.value = money(s.monthly);
    el.hidTimeline.value = (m1.never ? 'Not on this path' : (m1.done ? 'Already there' : durShort(m1.m))) + ' to $100K at ' + s.rate + '%';

    drawChart();
    if (save) { store(false, { start: s.start, monthly: s.monthly, rate: s.rate }); }
  }

  /* ---------- chart ---------- */
  function drawChart() {
    if (!el.chart || !last) { return; }
    var s = last.s, ms = last.ms;
    var hit = ms.filter(function (x) { return x.m > 0; });
    var end = ms[2].m > 0 ? ms[2].m
      : ms[2].done ? 120
      : (hit.length ? Math.min(CAP, hit[hit.length - 1].m + 60) : 360);
    end = Math.max(24, Math.min(CAP, end));
    var pts = series(s.start, s.monthly, s.rate, end);

    var W = Math.max(280, Math.round(el.chart.clientWidth || 600));
    var H = W < 560 ? 230 : 300;
    var P = { l: 48, r: 14, t: 22, b: 28 };
    var iw = W - P.l - P.r, ih = H - P.t - P.b;
    var maxB = pts[pts.length - 1].b;
    var step = maxB > 1.2e6 ? 500000 : (maxB > 600000 ? 200000 : 100000);
    var yMax = Math.max(step, Math.ceil(maxB / (step / 2)) * (step / 2));
    function X(m) { return P.l + (m / end) * iw; }
    function Y(v) { return P.t + ih - (v / yMax) * ih; }

    // downsample for the path
    var every = Math.max(1, Math.ceil(pts.length / 220)), path = [];
    for (var i = 0; i < pts.length; i += every) { path.push(pts[i]); }
    if (path[path.length - 1] !== pts[pts.length - 1]) { path.push(pts[pts.length - 1]); }
    function line(key) { return path.map(function (p, j) { return (j ? 'L' : 'M') + X(p.m).toFixed(1) + ' ' + Y(p[key]).toFixed(1); }).join(''); }
    function area(key) { return line(key) + 'L' + X(end).toFixed(1) + ' ' + Y(0).toFixed(1) + 'L' + X(0).toFixed(1) + ' ' + Y(0).toFixed(1) + 'Z'; }

    var svg = '<svg viewBox="0 0 ' + W + ' ' + H + '" width="' + W + '" height="' + H + '" role="img" aria-labelledby="mkChartT">' +
      '<title id="mkChartT">Balance over ' + durLong(end) + ': deposits versus growth</title>';
    for (var v = 0; v <= yMax; v += step) {
      svg += '<line class="mk-grid" x1="' + P.l + '" x2="' + (W - P.r) + '" y1="' + Y(v) + '" y2="' + Y(v) + '"/>' +
        '<text x="' + (P.l - 8) + '" y="' + (Y(v) + 4) + '" text-anchor="end">' + (v ? moneyK(v) : '$0') + '</text>';
    }
    // x ticks: calendar years
    var years = end / 12, ys = [1, 2, 5, 10, 20].filter(function (k) { return years / k <= 7; })[0] || 25;
    // month offset of next January, then every `ys` years on round years
    var now = new Date(), firstJan = now.getFullYear() + 1, off = 12 - now.getMonth();
    var yr = ys >= 5 ? Math.ceil(firstJan / ys) * ys : firstJan;
    for (var mm = off + 12 * (yr - firstJan); mm <= end; mm += 12 * ys, yr += ys) {
      if (X(mm) < P.l + 14) { continue; }
      svg += '<text x="' + X(mm).toFixed(1) + '" y="' + (H - 8) + '" text-anchor="middle">' + yr + '</text>';
    }
    svg += '<path class="mk-total" d="' + area('b') + '"/><path class="mk-dep" d="' + area('d') + '"/>' +
      '<path class="mk-total-l" d="' + line('b') + '"/><path class="mk-dep-l" d="' + line('d') + '"/>';
    TARGETS.forEach(function (t) {
      if (t <= yMax) { svg += '<line class="mk-goal" x1="' + P.l + '" x2="' + (W - P.r) + '" y1="' + Y(t) + '" y2="' + Y(t) + '"/>'; }
    });
    hit.forEach(function (x) {
      var cx = X(x.m), cy = Y(x.t), right = cx > W - 90;
      svg += '<circle class="mk-dot" cx="' + cx.toFixed(1) + '" cy="' + cy.toFixed(1) + '" r="5"/>' +
        '<text class="mk-lbl" x="' + (right ? cx - 9 : cx + 9).toFixed(1) + '" y="' + (cy - 8).toFixed(1) + '" text-anchor="' + (right ? 'end' : 'start') + '">' + dateIn(x.m) + '</text>';
    });
    svg += '</svg>';
    el.chart.innerHTML = svg;

    if (el.chartNote) {
      var endB = pts[pts.length - 1];
      var g = Math.max(0, endB.b - endB.d);
      el.chartNote.innerHTML = 'By ' + dateIn(end, true) + ': <strong>' + money(endB.d) + '</strong> of your money, <strong>' + money(g) + '</strong> of growth.';
    }
  }

  /* ---------- copy link ---------- */
  function shareUrl() {
    var s = last ? last.s : state;
    return 'https://' + (root.getAttribute('data-share-url') || 'www.mikeymoran.com/pages/first-100k-calculator') +
      '?start=' + Math.round(s.start) + '&monthly=' + Math.round(s.monthly) + '&rate=' + s.rate;
  }
  function flash(t) { if (el.msg) { el.msg.textContent = t; clearTimeout(flash.t); flash.t = setTimeout(function () { el.msg.textContent = ''; }, 4000); } }
  function copyLink() {
    var url = shareUrl();
    var ok = function () { flash('Link copied. Whoever opens it sees these numbers.'); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(ok, function () { legacyCopy(url) ? ok() : flash(url); });
    } else if (legacyCopy(url)) { ok(); } else { flash(url); }
  }
  function legacyCopy(t) {
    try {
      var ta = document.createElement('textarea');
      ta.value = t; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      var ok = document.execCommand('copy'); document.body.removeChild(ta); return ok;
    } catch (e) { return false; }
  }

  /* ---------- init ---------- */
  var q = new URLSearchParams(location.search);
  var saved = store(true) || {};
  var fromUrl = q.has('start') || q.has('monthly') || q.has('rate');
  var init = {
    start: q.has('start') ? num(q.get('start')) : (saved.start != null ? saved.start : DEF.start),
    monthly: q.has('monthly') ? num(q.get('monthly')) : (saved.monthly != null ? saved.monthly : DEF.monthly),
    rate: q.has('rate') ? clampRate(q.get('rate')) : (saved.rate != null ? clampRate(saved.rate) : DEF.rate)
  };
  el.start.value = init.start ? init.start.toLocaleString('en-US') : '';
  el.monthly.value = init.monthly ? init.monthly.toLocaleString('en-US') : '';
  el.rate.value = init.rate;

  [el.start, el.monthly].forEach(function (input) {
    on(input, 'input', function () { render(true); });
    on(input, 'blur', function () { fmtInput(input); });
  });
  on(el.rate, 'input', function () { render(true); });
  for (var c = 0; c < chips.length; c++) {
    on(chips[c], 'click', function () {
      el.monthly.value = Number(this.getAttribute('data-monthly')).toLocaleString('en-US');
      render(true);
    });
  }
  on($('mkReset'), 'click', function () {
    el.start.value = DEF.start.toLocaleString('en-US');
    el.monthly.value = DEF.monthly.toLocaleString('en-US');
    el.rate.value = DEF.rate;
    try { localStorage.removeItem(STORE); } catch (e) { /* private mode */ }
    render(false);
  });
  on($('mkCopy'), 'click', copyLink);
  on($('mkEmailGo'), 'click', function () {
    var keep = $('mkKeep');
    if (keep) { keep.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    var input = keep && keep.querySelector('input[type="email"]');
    if (input) { setTimeout(function () { input.focus({ preventScroll: true }); }, 450); }
  });
  on($('mkDockGo'), 'click', function () { if (el.result) { el.result.scrollIntoView({ behavior: 'smooth', block: 'start' }); } });

  if (window.ResizeObserver && el.chart) {
    var rw = 0;
    new ResizeObserver(function (en) {
      var w = Math.round(en[0].contentRect.width);
      if (w && Math.abs(w - rw) > 8) { rw = w; drawChart(); }
    }).observe(el.chart);
  }

  // mobile dock: visible while the inputs are on screen and the result isn't
  if (el.dock && window.IntersectionObserver && el.result) {
    var vis = { res: true, inp: true };
    var upd = function () { el.dock.classList.toggle('is-on', !vis.res && vis.inp); el.dock.setAttribute('aria-hidden', String(!(!vis.res && vis.inp))); };
    new IntersectionObserver(function (en) { vis.res = en[0].isIntersecting; upd(); }, { threshold: 0.15 }).observe(el.result);
    var inp = $('mkInputs');
    if (inp) { new IntersectionObserver(function (en) { vis.inp = en[0].isIntersecting; upd(); }, { threshold: 0 }).observe(inp); }
  }

  /* ---------- email form: post to a hidden iframe, confirm when it lands ---------- */
  var form = $('mkForm'), sink = $('mkSink'), okBox = $('mkOk');
  if (form && sink) {
    form.addEventListener('submit', function () {
      var email = form.querySelector('input[type="email"]');
      if (!email || !email.value || !email.checkValidity()) { return; }
      render(true);
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
      var done = false;
      var finish = function () {
        if (done) { return; }
        done = true;
        form.hidden = true;
        if (okBox) { okBox.hidden = false; }
      };
      sink.addEventListener('load', finish, { once: true });
      setTimeout(finish, 5000);
    });
  }

  render(fromUrl);
})();
